import React, { useEffect, useState } from "react";
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles} from '@material-ui/core/styles';

import { Alert } from '@material-ui/lab';
import { AlertTitle } from '@material-ui/lab';
import { useLocation } from "react-router";
import { Link, useHistory } from "react-router-dom";
import axios from "./helpers/API";
import logo from "./assets/logo-avellaneda.png";  
import * as Yup from "yup";
import { useFormik } from "formik";
import { InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ForgotPassword from "ForgotPassword";
import { errorBackendMsg  } from "helpers/helpers";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#232323",
    minWidth: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  card: {
    backgroundColor: theme.palette.secondary.main,
  },
  cardContent: {
    backgroundColor: "#fff"
  }
}));



function Login() {
  const location = useLocation();
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(false);
  const [olvide, setOlvide] = useState(false);

  const info = location && location.state && location.state.info ? location.state.info : false
  const msgInfo = location && location.state && location.state.msgInfo ? location.state.msgInfo : false

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    document.title = "Mda - Turnos Turnos Moratoria - Login";
  }, []);

  const history = useHistory();

  React.useEffect(() => {
    // Si va al login, no debe que tener datos guardados
    localStorage.removeItem("usuariosData")
  }, [])

  const login = (json) => {
    const usuariosData = {};
    axios
      .post("/seguridad/usuarios/login", json)
      .then(function (response) {
        if (!response.data.error) {
          usuariosData["token"] = response.data.token;
          usuariosData["apellido"] = response.data.apellido || "";
          usuariosData["nombre"] = response.data.nombre || "";
          usuariosData["username"] = response.data.username || "";
          localStorage.setItem("usuariosData", JSON.stringify(usuariosData));
          const forceChangePass = response.data.cambiarPassword
            ? response.data.cambiarPassword
            : false;
          if (forceChangePass) {
            history.push({
              pathname: "/cuenta/cambiarClave",
              state: { showSidebar: false },
            });
          } else {
            history.push({
              pathname: "/administracion",
              state: { showSaludo: true },
            });
          }
        } else {
          setError(true)
          setMsg(response.data.msg);
        }
      })
      .catch(function (error) {
        console.log(error);
        setError(true)
        setMsg(errorBackendMsg(error))
      });
  };

  const classes = useStyles();

  const validationSchema = Yup.object({
    identificador: Yup.string().required("Campo obligatorio"),
    password: Yup.string().required("Campo obligatorio"),
  });

  const formik = useFormik({
    initialValues: {
      identificador: "",
      password: ""
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(JSON.stringify(values, null, 2));
      login(values)
    },
  });

  return (
    <Grid
      className={classes.root}
      spacing={0}
      alignItems="center"
      justifyContent="center"
      container
    >
      {!olvide ?
        <form onSubmit={formik.handleSubmit}>
          <Card className={classes.card}>
            <img
              style={{ padding: 20 }}
              src={logo}
            />
            <CardContent className={classes.cardContent}>
              {error &&
                <Box mb={2}>
                  <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {msg}
                  </Alert>
                </Box>
              }
              {info &&
                <Box mb={2}>
                  <Alert severity="info">
                   {msgInfo}
                  </Alert>
                </Box>
              }
              <Box>
                <TextField
                  fullWidth
                  label="Usuario"
                  type="text"
                  id="identificador"
                  name="identificador"
                  value={formik.values.identificador}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.identificador &&
                    Boolean(formik.errors.identificador)
                  }
                  helperText={
                    formik.touched.identificador && formik.errors.identificador
                  }
                />
              </Box>
              <Box mt={1}>
                <TextField
                  fullWidth
                  label="Contraseña"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.password &&
                    Boolean(formik.errors.password)
                  }
                  helperText={
                    formik.touched.password && formik.errors.password
                  }
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box mt={3}>
                <Link to={"#"} onClick={() => setOlvide(true)}>
                  Olvide mi contraseña
                </Link>
              </Box>
              <Box mt={3}>
                <Button fullWidth variant="contained" color="primary" type="submit">
                  Iniciar Sesión
                </Button>
              </Box>
            </CardContent>
          </Card>
        </form>
        :
        <ForgotPassword /> 
      }
    </Grid >
  );
}

export default Login;
